<template>
  <v-overlay v-model="centerLoading" :scrim="false" class="custom_centered_overlay">
    <v-progress-circular color="green" indeterminate size="64"></v-progress-circular>
  </v-overlay>

  <v-app id="app_add_leads">
    <v-container fluid>
      <v-row>
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">ADD NEW VISIT</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Create new visits according to your requirements.</p>
        </v-col>
        <v-col class="px-4 mt-7" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical mx-4" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" style="border-radius: 2px;" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon> BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" style="border-radius: 2px;">
        <template v-slot:title>
          <p class="custom_page_component_main_title pa-3">CREATE NEW VISIT DETAILS</p>
        </template>
        <v-divider thickness="2"></v-divider>

        <v-card-text>
          <v-form ref="form">
            <v-row class="mt-2">
              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-text-field
                  v-model="lead.title"
                  :counter="30"
                  maxlength="30"
                  :rules="[
                    v => !!v || 'New Visit Title is required',
                    v => (v && v.trim().length > 0) || 'Cannot be just blank spaces',
                    v => (v && v.length <= 30) || 'Max 30 characters allowed'
                  ]"
                  label="New Visit Title *"
                  variant="outlined"
                  density="comfortable"
                  :class="['custom_input_field_color', lead.title && lead.title.length >= 30 ? 'error-border' : '']"
                  style="border-radius: 2px;"
                ></v-text-field>
                
                <p v-if="errorMessage" class="mt-0" style="color: red;" type="error">
                  {{ errorMessage }}
                </p>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-autocomplete
                  v-model="lead.Area"
                  :items="Area"
                  :loading="mAreaLoading"
                  :rules="[v => !!v || 'Area Code is required']"
                  clearable
                  item-title="label"
                  item-value="value"
                  label="Area Code *"
                  variant="outlined"
                  density="comfortable"
                  class="custom_input_field_color"
                  style="border-radius: 2px;"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-autocomplete
                  v-model="lead.assignAgent"
                  :items="filteredAgents"
                  :loading="mRepLoading"
                  :rules="[v => !!v || 'Assign Sales Rep is required']"
                  clearable
                  item-title="label"
                  item-value="id"
                  label="Assign Sales Rep *"
                  variant="outlined"
                  density="comfortable"
                  class="custom_input_field_color"
                  style="border-radius: 2px;"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                <v-date-input
                  v-model="lead.assignDate"
                  :min="new Date().toISOString().split('T')[0]"
                  :rules="[v => !!v || 'Assign Date is required']"
                  clearable
                  label="Assign Date *"
                  prepend-inner-icon="$calendar"
                  prepend-icon=""
                  variant="outlined"
                  density="comfortable"
                  class="custom_input_field_color"
                  style="border-radius: 2px;"
                ></v-date-input>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-divider class="mb-4 mt-2"></v-divider>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="7" lg="7">
                    <p class="custom_page_main_sub_title">
                      <strong>USE MAPS TO SELECT A NEW VISIT LOCATION</strong>
                    </p>
                    <p class="custom_page_main_sub_title mt-2" style="opacity: 0.6; line-height: 26px">
                      In here, you can set the new visit location by searching the location or dragging & placing it. Click the add icon in the map pin to instantly add it to your table.
                    </p>

                    <Map ref="map" :center="mapCenter" :zoom="7" style="height: 600px; border-radius: 2px;" class="d-flex custom_outlet_selection_map mt-2 custom_card_box">
                      <Marker v-if="markerPosition" :icon="customIcon" :position="markerPosition"/>
                    </Map>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="5" lg="5">
                    <v-row>
                      <v-col cols="12">
                        <v-card border="md opacity-1" style="border-radius: 2px;">
                          <v-card-text class="ma-4 mb-0">
                            <v-text-field
                              v-model="searchAddress"
                              append-inner-icon="mdi-magnify"
                              label="Search Address"
                              placeholder="Type Search address"
                              variant="outlined"
                              id="search_address"
                              density="comfortable"
                              class="custom_input_field_color"
                            />
                          </v-card-text>
                        </v-card>

                        <v-card border="md opacity-1" class="mt-4" style="border-radius: 2px;">
                          <v-card-text class="ma-4 mb-0">
                            <v-text-field
                              v-model="searchMapLink"
                              append-inner-icon="mdi-link-variant"
                              label="Search Google Maps Link"
                              placeholder="Paste Full or Short Google Maps Link"
                              variant="outlined"
                              id="search_map_link"
                              density="comfortable"
                              class="custom_input_field_color"
                              @click:append-inner="handleMapLinkSearch"
                              @keyup.enter="handleMapLinkSearch"
                            />
                          </v-card-text>
                        </v-card>

                        <v-card v-if="lead.lat && lead.lng" border="md opacity-1" class="mt-4" color="#f9f9f9" elevation="0" style="border-radius: 2px;">
                          <v-card-text>
                            <p class="text-subtitle-1 font-weight-bold mb-3" style="color: #800080;">Location Details</p>
                            
                            <v-text-field
                              v-model="lead.instituteName"
                              label="Institute Name *"
                              placeholder="Enter Institute Name"
                              variant="outlined"
                              density="compact"
                              :counter="30"
                              maxlength="30"
                              :rules="[
                                v => !!v || 'Institute Name is required',
                                v => (!v || v.length <= 30) || 'Max 30 characters allowed'
                              ]"
                              :error="instituteNameError"
                              :error-messages="instituteNameError ? ['Institute Name is required'] : []"
                              :class="['mb-4 bg-white custom_input_field_color', instituteNameError ? 'error-border' : '']"
                              hide-details="auto"
                              style="border-radius: 2px;"
                            ></v-text-field>

                            <div class="mb-2 mt-4">
                              <v-icon size="small" color="grey-darken-1" class="mr-2">mdi-map-marker</v-icon>
                              <strong>Address:</strong>
                              <span class="ml-1">{{ lead.address || 'Address not found' }}</span>
                            </div>
                            <div class="mb-2">
                              <v-icon size="small" color="grey-darken-1" class="mr-2">mdi-crosshairs-gps</v-icon>
                              <strong>Latitude:</strong>
                              <span class="ml-1">{{ lead.lat ? lead.lat.toFixed(6) : '—' }}</span>
                            </div>
                            <div>
                              <v-icon size="small" color="grey-darken-1" class="mr-2">mdi-crosshairs-gps</v-icon>
                              <strong>Longitude:</strong>
                              <span class="ml-1">{{ lead.lng ? lead.lng.toFixed(6) : '—' }}</span>
                            </div>
                          </v-card-text>
                        </v-card>

                        <v-btn 
                          v-if="lead.lat && lead.lng"
                          class="mt-4 w-100 font-weight-bold" 
                          size="x-large"
                          style="background-color: #800080; color: white; border-radius: 2px;"
                          @click="addLocationFromMapToTable"
                        >
                          <v-icon left class="mr-2">mdi-plus-circle</v-icon> ADD LOCATION TO TABLE
                        </v-btn>
                        
                        <v-divider class="mt-6"></v-divider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-divider class="mb-4"></v-divider>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <p class="custom_page_main_sub_title">
                      <strong>NEW VISIT DESCRIPTION *</strong>
                    </p>
                    <p class="custom_page_main_sub_title mt-2" style="opacity: 0.6; line-height: 26px">
                      Type the new visit description below. Maximum character count is 300.
                    </p>
                    <v-card class="mt-5" elevation="1" :style="{ border: descriptionError ? '2px solid red' : '1px solid rgba(0,0,0,0.12)', borderRadius: '2px', height: '300px', display: 'flex', flexDirection: 'column' }">
                      <v-divider></v-divider>
                      <Editor 
                        v-model="lead.description" 
                        :defaultConfig="editorConfig" 
                        :mode="mode" 
                        @onCreated="handleCreated" 
                        @onMaxLength="handleMaxLength"
                        style="flex: 1; overflow-y: hidden;" 
                      />
                    </v-card>
                    <div class="d-flex justify-end mt-2">
                      <span :style="{ color: descriptionCharCount > 300 ? 'red' : 'grey', fontSize: '13px', fontWeight: 'bold' }">
                        {{ descriptionCharCount }} / 300 Characters
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-divider class="mt-1 mb-3"></v-divider>
                <p class="custom_page_main_sub_title">
                  <strong>SELECTED NEW VISITS LIST</strong>
                </p>
                <p class="custom_page_main_sub_title mt-2" style="opacity: 0.6">
                  The following table shows all the institutes related to the above-defined new visit.
                </p>

                <v-card class="mt-4 custom_card_box" elevation="1" border="sm opacity-1" style="border-radius: 2px;">
                  <v-toolbar color="white" class="pa-3" flat>
                    <v-divider vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-col cols="5">
                      <v-text-field
                        v-model="search"
                        append-inner-icon="mdi-magnify"
                        density="comfortable"
                        class="custom_input_field_color"
                        clearable
                        hide-details
                        label="Search"
                        variant="outlined"
                        style="border-radius: 2px;"
                      ></v-text-field>
                    </v-col>
                  </v-toolbar>

                  <v-divider></v-divider>

                  <v-card-text>
                    <v-data-table
                      :headers="headers"
                      :items="filteredItems"
                      :items-per-page="itemsPerPage"
                      :search="search"
                      density="comfortable"
                      class="custom_table_normal"
                      hide-default-footer
                    >
                      <template v-slot:[`item.lat`]="{ item }">
                        {{ item.lat ? item.lat.toFixed(6) : '—' }}
                      </template>
                      <template v-slot:[`item.lng`]="{ item }">
                        {{ item.lng ? item.lng.toFixed(6) : '—' }}
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <div class="d-flex align-center">
                          <span class="mr-2 text-caption font-weight-bold" :style="!item.selected ? 'color: #800080;' : 'color: grey;'">REMOVE</span>
                          <v-switch
                            v-model="item.selected"
                            color="#800080"
                            hide-details
                            inset
                            density="compact"
                            @update:model-value="removeItemIfDeselected(item)"
                          ></v-switch>
                          <span class="ml-2 text-caption font-weight-bold" :style="item.selected ? 'color: #800080;' : 'color: grey;'">ADD</span>
                        </div>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider thickness="2"></v-divider>

        <v-card-actions class="float-end pa-4">
          <v-btn size="x-large" style="background-color: #800080; color: white; border-radius: 2px;" class="pl-5 pr-5 mr-3" @click="addLead">Create New Visit</v-btn>
          <v-btn size="x-large" variant="outlined" style="border-radius: 2px;" @click="cancelAndRefresh()">Cancel</v-btn>
        </v-card-actions>
      </v-card>

      <v-dialog v-model="leadsBulkUploadDialog" fullscreen id="app_add_leads">
        <v-card flat>
          <v-toolbar style="border-radius: 0 !important;" class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')" @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn 
              variant="flat" 
              style="background-color: #800080 !important; color: #ffffff !important; border-radius: 2px;" 
              @click="leadsBulkUploadDialog = false"
            >
              CLOSE
            </v-btn>
          </v-toolbar>

          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1" style="border-radius: 2px;">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">UPLOAD SPREADSHEET</v-card-title>
                </template>
              </v-card>

              <v-card class="px-3 mx-6 mt-3 custom_card_box" elevation="1" border="sm opacity-1" style="border-radius: 2px;">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="12" md="5" lg="5">
                    <p class="text-body-1 font-weight-medium mb-4 mt-4">
                      Upload your lead bulk data set using excel or a csv file.
                    </p>
                    <v-divider></v-divider>
                    <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                      <v-file-input accept=".csv, .xls, .xlsx"
                                    clearable density="comfortable"
                                    class="custom_input_field_color mt-3" label="Upload your Excel or CSV file *"
                                    counter show-size variant="outlined"
                                    style="border-radius: 2px;"
                                    @change="handleFileUpload"></v-file-input>
                    </v-col>
                  </v-col>

                  <v-col class="d-flex align-center justify-center" cols="1">
                    <v-divider :thickness="2" vertical></v-divider>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <v-card class="d-flex align-center justify-space-between pa-4 mt-3" color="#F0F0F0" flat width="100%" style="border-radius: 2px;">
                          <v-card class="mr-4" border="lg" style="border-radius: 2px;">
                            <p class="mb-0 text-body-2 font-weight-bold">DOWNLOAD SAMPLE TEMPLATE</p>
                          </v-card>
                          <v-divider vertical></v-divider>
                          <v-btn style="background-color: #800080; color: white; border-radius: 2px;" size="x-large" @click="downloadTemplate">
                            DOWNLOAD
                          </v-btn>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-card v-if="bulkItems.length > 0" flat>
                  <v-card-text>
                    <v-divider class="mb-4 "></v-divider>
                    <v-data-table :headers="bulkHeaders" :items="bulkItems" :items-per-page="itemsPerPage" class="custom_table_normal">
                      <template v-slot:[`item.subCategory`]="{ item }">
                        <span class="red--text">{{ item.subCategory }}</span>
                      </template>
                      <template v-slot:[`item.assignAgent`]="{ item }">
                        <span>{{ item.assignAgent }}<br/><span class="red--text">{{ item.regNum }}</span></span>
                      </template>
                    </v-data-table>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="float-end pa-4">
                    <v-btn v-if="permissions.write" :disabled="bulkItems.length === 0" style="background-color: #800080; color: white; border-radius: 2px;" size="large" @click="uploadBulkLead">Upload</v-btn>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000" location="top-right" outlined>
        {{ snackbarMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn icon v-bind="attrs" @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" :right="snackAlert.snackBarRight"
                  :top="snackAlert.snackBarTop" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import { Map, Marker } from '@fawmi/vue-google-maps';
import { Editor } from '@wangeditor/editor-for-vue';
import * as XLSX from 'xlsx';

import '@wangeditor/editor/dist/css/style.css';
import { i18nChangeLanguage } from '@wangeditor/editor';

import { getPermissions } from '@/plugins/permissions';

i18nChangeLanguage('en');

export default {
  components: { Editor, Map, Marker },
  name: 'AddLeads',
  data() {
    return {
      baseURL: process.env.VUE_APP_API_BASE_URL,
      permissions: { read: false, write: false, delete: false },
      dataDescription: '',
      errorMessage: '',
      descriptionError: false,
      instituteNameError: false,
      searchAddress: '',
      searchMapLink: '',
      triggerMapUpdate: null,
      snackbar: false,
      snackbarColor: '',
      snackbarMessage: '',
      centerLoading: false,
      mAreaLoading: false,
      mRepLoading: false,
      lead: {
        title: '',
        address: null,
        lat: null,
        lng: null,
        instituteName: '',
        description: '',
        assignAgent: null,
        Area: null,
        assignDate: null,
      },
      snackAlert: {
        snackbar: false,
        snackColor: '',
        snackMessage: '',
        snackBarRight: false,
        snackBarTop: true,
      },
      filteredAgents: [],
      Area: [],
      bulkFile: null,
      bulkItems: [],
      bulkHeaders: [
        { text: 'Main Category', value: 'mainCategory', title: 'MAIN CATEGORY' },
        { text: 'Sub Category', value: 'subCategory', title: 'Sub Category' },
        { text: 'Institute Name', value: 'instituteName', title: 'Institute Name' },
        { text: 'Area', value: 'area', title: 'Area' },
        { text: 'Address', value: 'address', title: 'Address' },
        {
          text: 'Assign Agent Registration Number',
          value: 'Assign Agent Registration Number',
          title: 'Assign Agent Registration Number',
        },
      ],
      headers: [
        { title: 'INSTITUTE NAME', value: 'instituteName', sortable: true },
        { title: 'ADDRESS', value: 'address', sortable: true },
        { title: 'LATITUDE', value: 'lat', sortable: true },
        { title: 'LONGITUDE', value: 'lng', sortable: true },
        { title: 'ACTION', value: 'action', sortable: false },
      ],
      checkLeadTileExist: [],
      items: [],
      itemsPerPage: 10,
      search: '',
      leadsBulkUploadDialog: false,
      mapCenter: { lat: 6.9271, lng: 79.8612 },
      customIcon: null,
      markerPosition: null,
      currentPoiName: null,
      infoWindow: null,
      editorRef: null,
      toolbarConfig: {},
      editorConfig: {},
      mode: 'simple',
    };
  },

  computed: {
    filteredItems() {
      const searchText = (this.search || '').toLowerCase();
      return this.items.filter((item) => {
        return (
          (item.instituteName?.toLowerCase() || '').includes(searchText) ||
          (item.address?.toLowerCase() || '').includes(searchText) ||
          (item.lat?.toString() || '').includes(searchText) ||
          (item.lng?.toString() || '').includes(searchText)
        );
      });
    },
    descriptionCharCount() {
      if (!this.lead.description) return 0;
      const doc = new DOMParser().parseFromString(this.lead.description, 'text/html');
      const plainText = doc.body.textContent || "";
      return plainText.length;
    }
  },

  watch: {
    'lead.Area'(val) {
      if (val) {
        this.fetchSalesReps(val);
      } else {
        this.filteredAgents = [];
        this.lead.assignAgent = null;
      }
    },
    'lead.description'() {
      if (this.descriptionCharCount > 0) {
        this.descriptionError = false;
      }
    },
    'lead.instituteName'(val) {
      if (val && val.trim().length > 0) {
        this.instituteNameError = false;
      }
    }
  },

  created() {
    this.editorConfig = {
      placeholder: 'Type description here...',
      maxLength: 300,
      toolbarConfig: {
        excludeKeys: [
          'headerSelect',
          'blockquote',
          '|',
          'bold',
          'underline',
          'italic',
          'through',
          'color',
          'bgColor',
          'clearStyle',
          'fontSize',
          'fontFamily',
          'lineHeight',
          'bulletedList',
          'numberedList',
          'todo',
          'justifyLeft',
          'justifyRight',
          'justifyCenter',
          'justifyJustify',
          'indent',
          'delIndent',
          'emotion',
          'insertLink',
          'insertImage',
          'insertTable',
          'codeBlock',
          'divider',
          'fullScreen',
        ]
      },
      hoverbarKeys: {
        'text': {
          menuKeys: []
        }
      }
    };
  },

  mounted() {
    this.permissions = getPermissions(0, 'Module Name');

    if (!this.permissions.read) {
      this.showSnackbar ? this.showSnackbar('Access Denied', 'error') : alert('Access Denied');
      this.$router.push('/dashboard'); 
    }
    this.fetchAreaCodes();
    this.fetchAllAgents();
    if (this.$refs.map) {
      this.$refs.map.$mapPromise
        .then((map) => this.mapInit(map))
        .catch((err) => {
          console.error('Error loading map:', err);
        });
    }

    if (window.google && window.google.maps) {
      this.customIcon = {
        url: 'https://maps.google.com/mapfiles/ms/icons/purple-dot.png',
        scaledSize: new window.google.maps.Size(40, 40),
      };
    }
  },

  methods: {
    formatCoordinate(coord) {
      if (coord === null || coord === undefined) return null;
      return Number(coord.toFixed(6));
    },
    handleMaxLength() {
      this.showSnackbar('Character limit exceeded! Maximum 300 characters allowed.', 'warning');
    },

    removeItemIfDeselected(item) {
      if (!item.selected) {
        this.items = this.items.filter((i) => i.id !== item.id);
        this.showSnackbar('Location removed from table.', 'success');
      }
    },

    async fetchAreaCodes() {
      this.mAreaLoading = true;
      try {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId'); 
        
        const apiUrl = `${this.baseURL}/api/area/user/${userId}`;

        const response = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const areaCodes = response.data.data;
        let areasArray = [];
        if (areaCodes) {
          areasArray = Array.isArray(areaCodes) ? areaCodes : [areaCodes];
        }

        this.Area = areasArray.map((a) => {
          if (typeof a === 'string') {
            return {
              label: a,
              value: a
            };
          } else {
            return {
              label: a.description ? `${a.area_code} - ${a.description}` : a.area_code,
              value: a.area_code,
            };
          }
        });
        
      } catch (error) {
        console.error('Error fetching Area codes:', error);
      } finally {
        this.mAreaLoading = false;
      }
    },

    async fetchSalesReps(areaCode) {
      this.mRepLoading = true;
      try {
        const token = localStorage.getItem('token');
        const url = `${this.baseURL}/api/getSalesRepByAreaCode?area_code=${encodeURIComponent(areaCode)}`;

        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        let reps = [];
        if (response.data && response.data.data) {
          reps = response.data.data;
        } else if (Array.isArray(response.data)) {
          reps = response.data;
        }

        this.filteredAgents = reps.map((r) => ({
          label: r.name,
          id: r.id,
        }));
      } catch (error) {
        console.error('Error fetching Sales Reps:', error);
      } finally {
        this.mRepLoading = false;
      }
    },

    async fetchAllAgents() {
      /* intentionally empty */
    },
    async fetchMainCategories() {
      /* intentionally empty */
    },
    async getAllProvinces() {
      /* intentionally empty */
    },

    getAgentName(id) {
      if (!id) return null;
      const agent = this.filteredAgents.find((a) => a.id === id);
      return agent ? agent.label : null;
    },

    showInfoWindow(map, marker, address, lat, lng) {
      if (!this.infoWindow) {
        this.infoWindow = new window.google.maps.InfoWindow();
      }

      const contentString = `
        <div style="color: black; min-width: 250px; padding: 5px 10px; font-family: sans-serif;">
          <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #ccc; padding-bottom: 5px; margin-bottom: 8px;">
            <h4 style="margin: 0; color: #800080; font-size: 16px;">Location Details</h4>
          </div>
          <p style="margin-bottom: 6px; font-size: 13px; line-height: 1.4;"><strong>Address:</strong><br/> ${address || 'Address not found'}</p>
          <div style="background: #f5f5f5; padding: 5px; border-radius: 4px; font-size: 12px; margin-bottom: 5px;">
            <strong>Lat:</strong> ${lat.toFixed(6)} <br/>
            <strong>Lng:</strong> ${lng.toFixed(6)}
          </div>
        </div>
      `;

      this.infoWindow.setContent(contentString);
      this.infoWindow.open(map, marker);
    },

    cleanGoogleConsentUrl(url) {
      if (!url) return url;
      if (url.includes('consent.google.com')) {
        try {
          const match = url.match(/[?&]continue=([^&]+)/);
          if (match && match[1]) {
            return decodeURIComponent(match[1]);
          }
        } catch (e) {
          console.warn('Failed to parse consent continue param:', e);
        }
      }
      return url;
    },

    async handleMapLinkSearch() {
      if (!this.searchMapLink) return;

      this.centerLoading = true;
      let urlToParse = this.searchMapLink.trim();
      let fallbackPlaceTitle = null;

      const isShortLink = urlToParse.includes('maps.app.goo.gl') || 
                          urlToParse.includes('goo.gl/maps') || 
                          urlToParse.includes('maps.page.link') || 
                          urlToParse.includes('g.page');

      if (isShortLink) {
        try {
          const microRes = await axios.get(`https://api.microlink.io/?url=${encodeURIComponent(urlToParse)}`, { timeout: 6000 });
          if (microRes.data && microRes.data.data) {
            if (microRes.data.data.title) {
              fallbackPlaceTitle = microRes.data.data.title;
            }
            if (microRes.data.data.url && !microRes.data.data.url.includes('consent.google')) {
              urlToParse = microRes.data.data.url;
            }
          }
        } catch (e) {
          console.warn('microlink initial fetch failed:', e.message);
        }

        let hops = 0;
        
        while (hops < 3 && (urlToParse.includes('goo.gl') || urlToParse.includes('maps.app.goo.gl') || urlToParse.includes('page.link') || urlToParse.includes('g.page'))) {
          let nextUrl = null;

          try {
            const unshortRes = await axios.get(`https://unshorten.me/json/${encodeURIComponent(urlToParse)}`, { timeout: 6000 });
            if (unshortRes.data && unshortRes.data.resolved_url) {
              nextUrl = this.cleanGoogleConsentUrl(unshortRes.data.resolved_url);
            }
          } catch (e) {
            console.warn('unshorten.me failed:', e.message);
          }

          if (!nextUrl || nextUrl === urlToParse || nextUrl.includes('goo.gl')) {
            try {
              const codeTabsRes = await axios.get(`https://api.codetabs.com/v1/proxy?quest=${encodeURIComponent(urlToParse)}`, { timeout: 6000 });
              const html = typeof codeTabsRes.data === 'string' ? codeTabsRes.data : JSON.stringify(codeTabsRes.data);
              let match = html.match(/URL=['"]?(https:\/\/(?:www\.)?google\.com\/(?:maps|search)[^'"\s>]+)['"]?/i) ||
                          html.match(/href=['"]?(https:\/\/(?:www\.)?google\.com\/(?:maps|search)[^'"\s>]+)['"]?/i) ||
                          html.match(/window\.location\.replace\(['"](https:\/\/(?:www\.)?google\.com\/(?:maps|search)[^'"\s>]+)['"]\)/i) ||
                          html.match(/<meta property="og:url" content="([^"]+)"/i);
              if (match && match[1]) {
                nextUrl = this.cleanGoogleConsentUrl(match[1].replace(/&amp;/g, '&'));
              }
            } catch (e) {
              console.warn('codetabs proxy failed:', e.message);
            }
          }

          if (!nextUrl || nextUrl === urlToParse || nextUrl.includes('goo.gl')) {
            try {
              const allOrigRes = await axios.get(`https://api.allorigins.win/get?url=${encodeURIComponent(urlToParse)}`, { timeout: 5000 });
              if (allOrigRes.data && allOrigRes.data.status && allOrigRes.data.status.url) {
                nextUrl = this.cleanGoogleConsentUrl(allOrigRes.data.status.url);
              }
            } catch (e) {
              console.warn('allorigins proxy failed:', e.message);
            }
          }

          if (nextUrl && nextUrl !== urlToParse) {
            urlToParse = nextUrl;
            hops++;
          } else {
            break;
          }
        }
      }

      urlToParse = this.cleanGoogleConsentUrl(urlToParse);

      let lat = null;
      let lng = null;
      let extractedName = null;
      let microAddress = null;

      if (fallbackPlaceTitle && fallbackPlaceTitle.includes('·')) {
          const parts = fallbackPlaceTitle.split('·');
          if (!extractedName) {
              extractedName = parts[0].trim();
          }
          microAddress = parts.slice(1).join('·').trim();
      }

      let placeMatch = urlToParse.match(/\/(?:place|search)\/([^/@?]+)/);
      if (placeMatch && placeMatch[1]) {
        extractedName = decodeURIComponent(placeMatch[1].replace(/\+/g, ' '));
        extractedName = extractedName.replace(/^[A-Z0-9]{4,8}\+[A-Z0-9]{2,3}\s*/, '').trim();
        extractedName = extractedName.replace(/,\s*$/, '');
      } else {
        let qMatch = urlToParse.match(/[?&](?:q|query)=([^&]+)/);
        if (qMatch && qMatch[1]) {
          let decodedQ = decodeURIComponent(qMatch[1].replace(/\+/g, ' '));
          if (!decodedQ.match(/^-?\d+\.\d+,\s*-?\d+\.\d+$/)) {
            extractedName = decodedQ.trim();
          }
        }
      }

      let coord3d4d = urlToParse.match(/!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/);
      if (coord3d4d) {
        lat = parseFloat(coord3d4d[1]);
        lng = parseFloat(coord3d4d[2]);
      } else {
        let coordAt = urlToParse.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
        if (coordAt) {
          lat = parseFloat(coordAt[1]);
          lng = parseFloat(coordAt[2]);
        } else {
          let coordParam = urlToParse.match(/[?&](?:q|query|ll|center)=(-?\d+\.\d+)(?:%2C|,)(-?\d+\.\d+)/);
          if (coordParam) {
            lat = parseFloat(coordParam[1]);
            lng = parseFloat(coordParam[2]);
          }
        }
      }

      if (lat === null && lng === null && extractedName && extractedName.match(/^-?\d+\.\d+,\s*-?\d+\.\d+$/)) {
        let parts = extractedName.split(',');
        lat = parseFloat(parts[0].trim());
        lng = parseFloat(parts[1].trim());
        extractedName = null;
      }

      const processLocation = (locationLat, locationLng, addressStr, placeNameExtracted) => {
        let bestAddress = addressStr;

        if (!bestAddress || bestAddress === 'Address not found' || bestAddress === placeNameExtracted || bestAddress.match(/^-?\d+\.\d+,\s*-?\d+\.\d+$/) || bestAddress.includes('Lat:')) {
            if (microAddress) {
                bestAddress = microAddress;
            } else {
                bestAddress = 'Address not found';
            }
        }
        
        if (this.triggerMapUpdate) {
          this.triggerMapUpdate(locationLat, locationLng, bestAddress, placeNameExtracted);
        }
        
        if (this.$refs.map && this.$refs.map.$mapPromise) {
          this.$refs.map.$mapPromise.then(map => {
            map.panTo(new window.google.maps.LatLng(locationLat, locationLng));
            map.setZoom(15);
          });
        }
        this.centerLoading = false;
      };

      const geocoder = new window.google.maps.Geocoder();

      if (lat !== null && lng !== null) {
        const latLng = new window.google.maps.LatLng(lat, lng);
        geocoder.geocode({ location: latLng }, (results, status) => {
          let finalAddress = 'Address not found';
          if (status === 'OK' && results && results.length > 0) {
            finalAddress = results[0].formatted_address;
          }
          processLocation(lat, lng, finalAddress, extractedName);
        });
      } else if (extractedName || fallbackPlaceTitle) {
        const searchQuery = extractedName || fallbackPlaceTitle;
        geocoder.geocode({ address: searchQuery }, (results, status) => {
          if (status === 'OK' && results && results.length > 0) {
            const loc = results[0].geometry.location;
            processLocation(loc.lat(), loc.lng(), results[0].formatted_address, extractedName);
          } else {
            this.showSnackbar('Could not find the location for this address on the map.', 'error');
            this.centerLoading = false;
          }
        });
      } else {
        this.showSnackbar('Could not extract coordinates or address from the map link.', 'error');
        this.centerLoading = false;
      }
    },

    addLocationFromMapToTable() {
      if (!this.lead.lat || !this.lead.lng) {
        this.showSnackbar('No valid location on map.', 'error');
        return;
      }

      if (!this.lead.instituteName || this.lead.instituteName.trim() === '') {
        this.instituteNameError = true;
        this.showSnackbar('Please enter the Institute Name before adding to the table.', 'error');
        return;
      }

      if (this.lead.instituteName.length > 30) {
        this.instituteNameError = true;
        this.showSnackbar('Institute Name cannot exceed 30 characters.', 'error');
        return;
      }

      this.instituteNameError = false;

      const fullAddress =
        this.lead.address && this.lead.address !== 'Address not found' && !this.lead.address.match(/^-?\d+\.\d+,\s*-?\d+\.\d+$/) && !this.lead.address.includes('Lat:')
          ? this.lead.address
          : 'Address not found';

      const formattedLat = this.formatCoordinate(this.lead.lat);
      const formattedLng = this.formatCoordinate(this.lead.lng);

      const exists = this.items.find((i) => i.lat === formattedLat && i.lng === formattedLng);
      if (!exists) {
        this.items.push({
          id: Date.now(),
          instituteName: this.lead.instituteName,
          address: fullAddress,
          lat: formattedLat,
          lng: formattedLng,
          selected: true,
        });
        this.showSnackbar('Location successfully added to table!', 'success');
        
        this.lead.lat = null;
        this.lead.lng = null;
        this.lead.address = null;
        this.lead.instituteName = '';
        this.currentPoiName = null;
        this.markerPosition = null;
        
      } else {
        this.showSnackbar('This location is already in the list.', 'warning');
      }

      if (this.infoWindow) this.infoWindow.close();
    },

    mapInit(map) {
      if (!window.google || !window.google.maps || !window.google.maps.places) {
        console.error('Google Maps Places API not loaded.');
        return;
      }
      const input = document.getElementById('search_address');
      if (!input) return;

      const autocomplete = new window.google.maps.places.SearchBox(input);
      const markers = [];
      map.addListener('bounds_changed', () => autocomplete.setBounds(map.getBounds()));

      const updateMarkerAndInfo = (lat, lng, address, title) => {
        const formattedLat = this.formatCoordinate(lat);
        const formattedLng = this.formatCoordinate(lng);

        markers.forEach((marker) => marker.setMap(null));
        markers.length = 0;

        this.lead.lat = formattedLat;
        this.lead.lng = formattedLng;
        
        if (address && address !== 'Address not found' && !address.match(/^-?\d+\.\d+,\s*-?\d+\.\d+$/) && !address.includes('Lat:')) {
           this.lead.address = address;
        } else {
           this.lead.address = 'Address not found';
        }
        
        this.currentPoiName = title || null;

        this.markerPosition = { lat: formattedLat, lng: formattedLng };

        const marker = new window.google.maps.Marker({
          map,
          icon: this.customIcon,
          position: { lat: formattedLat, lng: formattedLng },
        });
        markers.push(marker);

        this.showInfoWindow(map, marker, this.lead.address, formattedLat, formattedLng);
        marker.addListener('click', () => {
          this.showInfoWindow(map, marker, this.lead.address, this.lead.lat, this.lead.lng);
        });
      };

      this.triggerMapUpdate = updateMarkerAndInfo;

      autocomplete.addListener('places_changed', () => {
        const places = autocomplete.getPlaces();
        if (places.length === 0) return;

        const bounds = new window.google.maps.LatLngBounds();
        const place = places[0];

        if (!place.geometry || !place.geometry.location) return;

        const address = place.formatted_address || place.name;
        
        this.searchAddress = address;
        if (input) input.value = address;

        updateMarkerAndInfo(
          place.geometry.location.lat(),
          place.geometry.location.lng(),
          address,
          place.name
        );

        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
        map.fitBounds(bounds);
      });

      window.google.maps.event.addListener(map, 'click', (e) => {
        if (e.placeId) {
          e.stop();
          const service = new window.google.maps.places.PlacesService(map);
          service.getDetails({ placeId: e.placeId }, (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              const address = place.formatted_address || place.name;
              updateMarkerAndInfo(
                place.geometry.location.lat(),
                place.geometry.location.lng(),
                address,
                place.name
              );
              
              this.searchAddress = address;
              if (input) input.value = address;
            }
          });
        } else {
          const lat = e.latLng.lat();
          const lng = e.latLng.lng();
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ location: e.latLng }, (results, status) => {
            let address = 'Address not found';
            if (status === 'OK' && results[0]) {
              address = results[0].formatted_address;
            }
            updateMarkerAndInfo(lat, lng, address, null);
            
            this.searchAddress = address;
            if (input) input.value = address;
          });
        }
      });
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      this.bulkFile = file;
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = jsonData[0].map((header) => (header ? header.toString().trim() : ''));
        const expectedHeaders = this.bulkHeaders.map((header) => header.text);

        const headersMatch =
          headers.length === expectedHeaders.length &&
          headers.every((header, index) => header === expectedHeaders[index]);

        if (!headersMatch) {
          this.snackbar = true;
          this.snackbarMessage = 'UPLOADED FILE WAS WRONG';
          this.snackbarColor = 'error';
          return;
        }

        const isSerialDate = (value) => !isNaN(value) && value > 0 && value < 2958465;
        const excelDateToJsDate = (serial) => {
          const jsDate = new Date(Date.UTC(1900, 0, serial - 1));
          return jsDate.toISOString().split('T')[0];
        };

        const dataRows = jsonData.slice(1).map((row) => {
          return headers.reduce((obj, header, index) => {
            let value = row[index];
            if (header === 'Assign Date' && isSerialDate(value)) {
              value = excelDateToJsDate(parseFloat(value));
            }
            obj[header] = value !== undefined && value !== null ? value.toString().trim() : '';
            return obj;
          });
        });

        this.bulkItems = dataRows;
      };

      reader.readAsArrayBuffer(file);
    },

    async uploadBulkLead() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');

      if (!this.bulkFile) {
        this.showSnackbar('No file selected for upload', 'error');
        return;
      }

      const formData = new FormData();
      formData.append('file', this.bulkFile);
      formData.append('userId', userId);

      this.centerLoading = true;

      try {
        await axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/leads/bulk-upload`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        this.showSnackbar('Bulk upload successful', 'success');
        window.location.href = '/leads-list';
      } catch (error) {
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data.error || 'An error occurred.';
          switch (status) {
            case 400:
              this.showSnackbar(`Validation Error: ${message}`, 'error');
              break;
            case 401:
              this.showSnackbar('Unauthorized. Please log in again.', 'error');
              this.$router.push('/login');
              break;
            case 404:
              this.showSnackbar('User or resource not found.', 'error');
              break;
            case 500:
              this.showSnackbar('Server error. Please try again later.', 'error');
              break;
            default:
              this.showSnackbar(`Error: ${message}`, 'error');
          }
        } else if (error.request) {
          this.showSnackbar('No response from the server. Please try again.', 'error');
        } else {
          this.showSnackbar('An unexpected error occurred. Please try again.', 'error');
        }
      } finally {
        this.centerLoading = false;
      }
    },

    async downloadTemplate() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      const url = `${process.env.VUE_APP_API_BASE_URL}/api/leads/download-template?userId=${userId}`;

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          this.showSnackbar('Failed to download template', 'error');
          return;
        }

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'template_leads_data.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        this.showSnackbar('Template download successfully!', 'success');
      } catch (error) {
        console.error('Error downloading template:', error);
      }
    },

    cancelAndRefresh() {
      window.location.reload();
    },

    backPageRoute() {
      this.$router.back();
    },

    homeReload() {
      window.location.href = '/dashboard';
    },

    handleCreated(editor) {
      this.editorRef = editor;
    },

    async addLead() {
      try {
        const { valid } = await this.$refs.form.validate();
        
        let hasCustomError = false;
        
        if (!this.lead.description || this.descriptionCharCount === 0) {
          this.descriptionError = true;
          hasCustomError = true;
        } else {
          this.descriptionError = false;
        }

        if (!valid || hasCustomError) {
          this.showSnackbar('Please fill all required fields.', 'error');
          return;
        }

        const selectedLeads = this.items.filter((item) => item.selected);
        if (selectedLeads.length === 0) {
          this.showSnackbar('Please select at least one lead location from map.', 'error');
          return;
        }

        this.centerLoading = true;
        const userId = parseInt(localStorage.getItem('userId')) || 1;
        const token = localStorage.getItem('token');
        const userType = localStorage.getItem('userType'); 

        const finalLeadsData = this.items
          .filter((item) => item.selected && item.lat && item.lng)
          .map((item) => ({
            institute_name: item.instituteName,
            address: item.address,
            latitude: this.formatCoordinate(item.lat),
            longitude: this.formatCoordinate(item.lng),
          }));

        let formattedAssignDate = null;
        if (this.lead.assignDate) {
          const d = new Date(this.lead.assignDate);
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          formattedAssignDate = `${year}-${month}-${day}`;
        }

        const leadData = {
          userId: userId,
          lead_title: this.lead.title,
          area_code: this.lead.Area,
          assign_saleRep: this.lead.assignAgent,
          salesRep_name: this.getAgentName(this.lead.assignAgent),
          assign_date: formattedAssignDate,
          discription: this.lead.description || '',
          selectedLeads: finalLeadsData,
        };

        const response = await axios.post(`${this.baseURL}/api/v1/lead/create`, leadData, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'content-type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (userType === 'AREA MANAGER') {
          try {
            let parentLeadId = response.data?.id || response.data?.data?.id || response.data?.lead_id;

            const listResponse = await axios.get(`${this.baseURL}/api/v1-selected-leads?userId=${userId}`, {
              headers: { Authorization: `Bearer ${token}` }
            });

            let createdLeadIds = [];

            if (listResponse.data && listResponse.data.data) {
              const newLeads = listResponse.data.data.filter(item => 
                (parentLeadId && item.lead_id === parentLeadId) || 
                (item.lead_title === this.lead.title)
              );
              
              createdLeadIds = newLeads.map(item => item.id);
            }

            if (createdLeadIds.length > 0) {
              for (const sLeadId of createdLeadIds) {
                try {
                  await axios.post(`${this.baseURL}/api/v1-selected-leads/${sLeadId}/approve`, 
                  { userId: userId }, 
                  {
                    headers: {
                      'X-Requested-With': 'XMLHttpRequest',
                      'content-type': 'application/json',
                      Authorization: `Bearer ${token}`,
                    }
                  });
                } catch (approveError) {
                  console.error(`Error approving lead ID ${sLeadId}:`, approveError);
                }
              }
            } else {
              console.warn("Could not match the new lead ID from the list.");
            }
          } catch (autoApproveError) {
            console.error("Auto approval process failed:", autoApproveError);
          }
        }

        this.showSnackbar('NEW VISIT WAS REGISTERED SUCCESSFULLY', 'success');
        this.centerLoading = false;

        setTimeout(() => {
          window.location.href = '/add-leads';
        }, 1500);
      } catch (error) {
        console.error('Error adding lead:', error);
        this.showSnackbar('Already Exists.', 'error');
        this.centerLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '../../styles/lead_management/add_leads.scss' as *;

.error-border :deep(.v-field__outline) {
  --v-field-border-color: red !important;
  opacity: 1 !important;
}
</style>